module.exports = __webpack_public_path__ + "img/block_1.45f1d148.webp";